import { useState, useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { ONBOARDING_LEAD_UNAUTHORIZED_EVENT } from '@/libs/axios/leadAxiosInstance';
import { clearOnboardingStorage } from '../utils/clearOnboardingStorage';

const STORAGE_KEY = 'onboarding_token';

const useOnboardingToken = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlToken = searchParams.get('token');

  const [token, setToken] = useState(() => {
    if (urlToken) return urlToken;
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (!urlToken) return;
    try {
      localStorage.setItem(STORAGE_KEY, urlToken);
    } catch (error) {
      console.error('Failed to persist onboarding token:', error);
    }
    setToken(urlToken);
    const next = new URLSearchParams(searchParams);
    next.delete('token');
    setSearchParams(next, { replace: true });
  }, [urlToken, searchParams, setSearchParams]);

  useEffect(() => {
    const onLeadUnauthorized = () => {
      clearOnboardingStorage();
      setToken(null);
    };
    window.addEventListener(
      ONBOARDING_LEAD_UNAUTHORIZED_EVENT,
      onLeadUnauthorized
    );
    return () =>
      window.removeEventListener(
        ONBOARDING_LEAD_UNAUTHORIZED_EVENT,
        onLeadUnauthorized
      );
  }, []);

  const clearToken = () => {
    clearOnboardingStorage();
    setToken(null);
  };

  return { token, clearToken };
};

export default useOnboardingToken;
